<template>
  <div id="wrapper">
    <LazyGlobalLoading v-if="loadingStore.show"/>
    <template v-else>
      <LazyLearningProSkillAssureHeader
          :is-in-progress="false"
          :title="myInfo.assessmentName"
          :organization-name="getOrgName"
      />
      <LazyLearningProSkillAssureCompleted :is-sample-assessment="isSampleAssessment"/>
      <LazyLearningProSkillAssureFooter />
    </template>
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref, useRoute, useRouter} from '#imports';
import {useUserStore} from '~/store/user/userStore';
import {useProSkillAssureService} from '~/composables/service/useProSkillAssureService';
import {
  ProSkillAssureAssessmentMyInfoModel
} from '~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentMyInfoModel';
import {RouteName} from '~~/package/enum/RouteName';
import {
  ProSkillManagerCandidateStatusType
} from '~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateStatusType';
import {LazyGlobalLoading} from '#components';
import {useLoadingStore} from '~/store/loading/loadingStore';
import { SignType, SignUIType } from "~/components/Sign/enum/SignType";
import { useDialogStore } from '~/store/dialog/dialogStore';
import DialogType from '~/components/Common/Dialog/model/DialogType';
import LearningConfirmPopupType from '~/components/Common/Dialog/dialog/LearningConfirmPopup/LearningConfirmPopupType';
import { useLoadingTimeoutGuide } from '~/composables/useLoadingTimeoutGuide';

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const loadingStore = useLoadingStore();
const dialogStore = useDialogStore();

const assessmentId = ref(parseInt(route.params.assessmentId as string));
const myInfo = ref(new ProSkillAssureAssessmentMyInfoModel());

// 로딩이 20초 이상 지속되면(네트워크 단발 유실 등) 새로고침 안내 팝업 노출 (TSK-10923)
useLoadingTimeoutGuide(() => {
  dialogStore.open({
    type: DialogType.LearningConfirmPopup,
    props: { type: LearningConfirmPopupType.CONNECT_FAIL },
    confirm: { event: () => window.location.reload() },
  });
});

const getOrgName = computed(() => myInfo.value.sampleAssessment ? 'Codepresso' : myInfo.value.organizationName);
const isSampleAssessment = computed(() => myInfo.value.sampleAssessment);

onMounted(() => {
  if (!userStore.isLogin()) goToHomePage();
  else getProSkillAssure();
});

onBeforeMount(() => {
  loadingStore.openLoading("");
})

const goToHomePage = () => {
  router.replace({
    name: RouteName.Sign,
    query: {
      uiType: SignUIType.LOGIN,
      type: SignType.CANDIDATE
    },
  });
}

const goToDashboardPage = () => {
  router.replace({name: RouteName.Dashboard})
}

// ASMT-CAND-14: 완료 페이지 가드 — COMPLETED도 sample도 아니면 /dashboard
const getProSkillAssure = () => {
  useProSkillAssureService().getProSkillAssureMyInfo(assessmentId.value)
      .then(proSkillAssureData => {
        myInfo.value = proSkillAssureData
        if(myInfo.value.status !== ProSkillManagerCandidateStatusType.COMPLETED && !myInfo.value.sampleAssessment) {
          goToDashboardPage()
        }
        loadingStore.closeLoading();
      }).catch(goToDashboardPage)
}
</script>
